export const PROJECT_DISCUSSION_CONFIG = {
    name            : 'Discussions',
    menuName        : 'Discussions',
    icon            : 'i5-discussion',
    // iconLight       : 'i5-discussion-light',
    image           : 'chats3',
    iconSvg         : 'isvg-chat-discussion',
    url             : 'discussion',
    stringId        : 'discussion',
    description     : 'List of project-related discussions.',
    inheritance     : false,
    isSingleton     : true,
}
